import { render, staticRenderFns } from "./advertisingManagement.vue?vue&type=template&id=2a08dcce&scoped=true"
import script from "./advertisingManagement.vue?vue&type=script&lang=js"
export * from "./advertisingManagement.vue?vue&type=script&lang=js"
import style0 from "./advertisingManagement.vue?vue&type=style&index=0&id=2a08dcce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a08dcce",
  null
  
)

export default component.exports